<template>
  <div class="detailPage" v-if="isDataLoaded">
    <p class="title">基本信息</p>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">组装单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.orderNumber">{{
            orderDetailData.orderNumber
          }}</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
            class="el-icon-edit allowSkip"
            @click="editOrderNumber(orderDetailData.orderNumber)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">客户：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customer">{{
            orderDetailData.customer.name
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">销售订单：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customerOrder">{{
            orderDetailData.customerOrder.orderNumber
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">SAP单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.sapOrderNumber">{{
            orderDetailData.sapOrderNumber
          }}</span>
          <span v-else>-</span>
          <i class="el-icon-edit allowSkip"
            @click="editSapOrderNumber(orderDetailData.sapOrderNumber)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">产品型号：</div>
        <div class="right">
          <span class="value" v-if="isDataLoaded">{{
            orderDetailData.product.code
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">裸机数量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.quantity">
            {{ orderDetailData.quantity }}PCS
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
              class="el-icon-edit allowSkip"
              @click="editQuantityBtn(orderDetailData.quantity)"
            ></i></span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">成品编码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.itemCode">
            {{ orderDetailData.itemCode }}
          </span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
            class="el-icon-edit allowSkip"
            @click="editItemCode(orderDetailData.itemCode)"
          ></i>
        </div>
      </li>
      <li>
        <div class="left">状态：</div>
        <div class="right">
          <span
            class="value"
            v-if="orderDetailData.status"
            :class="{ danger: orderDetailData.status.code == 'LOCKED' }"
            >{{ orderDetailData.status.title }}</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">下单时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.orderDate">
            {{ orderDetailData.orderDate }}
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">结单时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.closedDate">{{
            orderDetailData.closedDate
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">开始生产时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.startDateTime">
            {{ orderDetailData.startDateTime }}
            <i class="el-icon-edit allowSkip" @click="editStartDate(orderDetailData.startDateTime)"></i>
          </span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">计划交货时间：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.planFinishDate">
            {{ orderDetailData.planFinishDate }}
            <i v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
              class="el-icon-edit allowSkip"
              @click="editPlanFinishDate(orderDetailData.planFinishDate)"
            ></i>
          </span>
          <span v-else>-
            <i v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
              class="el-icon-edit allowSkip"
              @click="editPlanFinishDate(orderDetailData.planFinishDate)"
            ></i></span>
        </div>
      </li>
      <li>
        <div class="left">已测试数量：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.testQuantity }} PCS</span>
        </div>
      </li>
      <li>
        <div class="left">直通率：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.rty }}</span>
        </div>
      </li>
      <li v-if="orderDetailData.agingTestRate">
        <div class="left">老化抽检率：</div>
        <div class="right">
          <span class="value">
            {{ orderDetailData.agingTestRate }}</span>
        </div>
      </li>
      <li>
        <div class="left">所有者：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.createUser">{{
            orderDetailData.createUser.name
          }}({{ orderDetailData.createUser.employeeNum }})</span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div v-if="isDataLoaded" class="titleBox">
      <p class="title">生产信息</p>
      <el-button type="primary" size="mini" v-if="orderDetailData.status && orderDetailData.status.code=='READY'" @click="updateProInfo"
        >修改</el-button>
    </div>
    <ul v-if="isDataLoaded" class="ulBox clearFloat">
      <li>
        <div class="left">SN模板：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.snPrefix">{{
            orderDetailData.snPrefix
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">流水长度：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.snLen">{{
            orderDetailData.snLen
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">起始SN：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.startSn">{{
            orderDetailData.startSn
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if='orderDetailData.snFid!="0" || orderDetailData.macFid!="0" || orderDetailData.uuidFid!="0" || orderDetailData.imeiFid!="0"'>
        <div class="left">导入的资料：</div>
        <div class="right">
          <span title="SN" class="value" v-if="orderDetailData.snFid == '****' && orderDetailData.snFid!=orderDetailData.uuidFid">{{ orderDetailData.snFid }}&nbsp;&nbsp;</span>
          <el-tooltip v-else-if="orderDetailData.snFid > 0 && orderDetailData.snFid!=orderDetailData.uuidFid" class="item" effect="dark" content="SN" placement="top">
            <span class="allowSkip" @click="downloadFile(orderDetailData.snFid, 'SN')">{{ orderDetailData.snFid }}&nbsp;&nbsp;</span>
          </el-tooltip>
          <span title="MAC" class="value" v-if="orderDetailData.macFid == '****'">{{ orderDetailData.macFid }}&nbsp;&nbsp;</span>
          <el-tooltip v-else-if="orderDetailData.macFid > 0" class="item" effect="dark" content="MAC" placement="top">
            <span class="allowSkip" @click="downloadFile(orderDetailData.macFid, 'MAC')">{{ orderDetailData.macFid }}&nbsp;&nbsp;</span>
          </el-tooltip>
          <span title="UUID" class="value" v-if="orderDetailData.uuidFid == '****'">{{ orderDetailData.uuidFid }}&nbsp;&nbsp;</span>
          <el-tooltip v-else-if="orderDetailData.uuidFid > 0" class="item" effect="dark" content="UUID" placement="top">
            <span class="allowSkip" @click="downloadFile(orderDetailData.uuidFid, 'UUID')">{{ orderDetailData.uuidFid }}&nbsp;&nbsp;</span>
          </el-tooltip>
          <span title="IMEI" class="value" v-if="orderDetailData.imeiFid == '****'">{{ orderDetailData.imeiFid }}&nbsp;&nbsp;</span>
          <el-tooltip v-else-if="orderDetailData.imeiFid > 0" class="item" effect="dark" content="IMEI" placement="top">
            <span class="allowSkip" @click="downloadFile(orderDetailData.imeiFid, 'UUID')">{{ orderDetailData.imeiFid }}&nbsp;&nbsp;</span>
          </el-tooltip>
        </div>
      </li>
      <!-- <li v-if="orderDetailData.importUuid">
        <div class="left">客户提供UUID：</div>
        <div class="right">
          <span class="value">            
            <span class="value" v-if="orderDetailData.uuidFid == '****'">
              已上传 (fid={{ orderDetailData.uuidFid }})
            </span>
            <span v-else-if="orderDetailData.uuidFid > 0">
              已上传 (fid=<span
                class="allowSkip"
                @click="downloadFile(orderDetailData.uuidFid, 'UUID')"
                >{{ orderDetailData.uuidFid }}</span
              >)
            </span>
            <span v-else>待上传</span>
          </span>
        </div>
      </li> -->
    </ul>
    <el-divider v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')"></el-divider>
    <p class="title" v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')">QC参数</p>
    <ul class="ulBox clearFloat" v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')">
      <li>
        <div class="left">首件前可生产：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.fai">{{orderDetailData.fai}} PCS</span>
          <span v-else>-</span>
          <i v-if="!orderDetailData.faiOrderNumber" class="el-icon-edit allowSkip" @click="editFai(orderDetailData.fai, orderDetailData.faiOrderNumber)"></i>
        </div>
      </li>
      <li>
        <div class="left">首件检验单号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.faiOrderNumber">{{orderDetailData.faiOrderNumber}}</span>
          <span v-else>-</span>
          <i v-if="!orderDetailData.faiOrderNumber" class="el-icon-edit allowSkip" @click="editFai(orderDetailData.fai, orderDetailData.faiOrderNumber)"></i>
        </div>
      </li>
      <li>
        <div class="left">送检批次：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.batchQuantity">{{orderDetailData.batchQuantity}} PCS/批</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status" class="el-icon-edit allowSkip" @click="editBatchQuantity(orderDetailData.batchQuantity)"></i>
        </div>
      </li>
      <li>
        <div class="left">批次抽检率：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.checkRate">{{orderDetailData.checkRate}} %</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status" class="el-icon-edit allowSkip" @click="editCheckRate(orderDetailData.checkRate)"></i>
        </div>
      </li>
      <li>
        <div class="left">批次合格率：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.qualifiedRate">{{orderDetailData.qualifiedRate}} %</span>
          <span v-else>-</span>
          <i v-if="orderDetailData.status" class="el-icon-edit allowSkip" @click="editQualifiedRate(orderDetailData.qualifiedRate)"></i>
        </div>
      </li><li>
        <div class="left">QC吞吐量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.qcBandwidth"
            >2.4G: {{ orderDetailData.qcBandwidth }}Mbps</span
          >
          <span class="value" v-if="orderDetailData.qcBandwidth2"
            >5G: {{orderDetailData.qcBandwidth2 }}Mbps</span
          >
          <span class="value" v-if="orderDetailData.qcLanBandwidth"
            >有线: {{orderDetailData.qcLanBandwidth }}Mbps</span
          >
          <span v-if="!orderDetailData.qcBandwidth && !orderDetailData.qcBandwidth2 && !orderDetailData.qcLanBandwidth">-</span>
          <i class="el-icon-edit allowSkip"
            @click="editQcBandwidth(orderDetailData.qcBandwidth, orderDetailData.qcBandwidth2, orderDetailData.qcLanBandwidth)"
          ></i>
        </div>
      </li>
    </ul>
    <el-divider v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')"></el-divider>
    <div class="titleBox">
      <p class="title">版本信息</p>
      <el-button type="primary" size="mini" @click="updateVersion" v-if="orderDetailData.status && orderDetailData.status.code=='READY'"
        >修改</el-button
      >
    </div>
    <ul v-if="isDataLoaded && (orderDetailData.product.productType.code=='AI_PC' || orderDetailData.product.productType.code=='AI_SERVER')" class="ulBox clearFloat">
      <li>
        <div class="left">OS版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.osVersion">{{
            orderDetailData.osVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">BIOS版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.fwVersion">{{
            orderDetailData.fwVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">EC分位：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.cfgVersion">{{
            orderDetailData.cfgVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">Key PartNum：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.md5sum">{{
            orderDetailData.md5sum
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <ul v-else class="ulBox clearFloat">
      <li>
        <div class="left">Flash固件版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.fwVersion && orderDetailData.fwFid==0">
            {{ orderDetailData.fwVersion }} <span class="text" style="color:#E6A23C;">(未上传)</span>
          </span>
          <span v-else-if="orderDetailData.fwVersion && orderDetailData.fwFid>0 && orderDetailData.upgFid>0">
              {{ orderDetailData.fwVersion }} (
                <span class="allowSkip" @click="downloadFile(orderDetailData.fwFid, '固件版本')">镜像包</span>&nbsp;|&nbsp;
                <span class="allowSkip" @click="downloadFile(orderDetailData.upgFid, '固件版本')">升级包</span>
                )
          </span>
          <span v-else-if="orderDetailData.fwVersion && orderDetailData.fwFid>0">
              {{ orderDetailData.fwVersion }} (<span class="allowSkip" @click="downloadFile(orderDetailData.fwFid, '固件版本')">镜像包</span>)
          </span>
          <span class="value" v-else>
            -
          </span>
        </div>
      </li>
      <li v-if="isDataLoaded && orderDetailData.product.productType.code=='IPC'">
        <div class="left">OTA版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.otaVersion">{{
            orderDetailData.otaVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">烧录工单：</div>
        <span v-if="orderDetailData.outwardStatus && orderDetailData.outwardOrderNumber">
          {{ orderDetailData.outwardOrderNumber}}
          <span v-if="orderDetailData.outwardStatus">
            【{{orderDetailData.outwardStatus.title}}】
          </span>
        </span>
        <span v-else>-</span>
        <i v-if="orderDetailData.status && orderDetailData.status.code=='READY' 
        && (orderDetailData.fwVersion || orderDetailData.mcuVersion || orderDetailData.wiFiVersion || orderDetailData.btVersion) && !orderDetailData.outwardStatus" 
        class="iconfont icon-fasong allowSkip" title='烧录工单' @click="outwardFw(orderDetailData.outwardOrderNumber)"></i>
      </li>
      <li>
        <div class="left">MCU版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.mcuFid!=0" >{{
            orderDetailData.mcuVersion
          }}
        (<span class="allowSkip" @click="downloadFile(orderDetailData.mcuFid, '固件版本')">镜像包</span> )
        </span>
           <span class="value" v-else-if="orderDetailData.mcuVersion">{{
            orderDetailData.mcuVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>      
      <li>
        <div class="left">WiFi固件版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.wifiFid!=0" >{{
            orderDetailData.wiFiVersion
          }}
        (<span class="allowSkip" @click="downloadFile(orderDetailData.wifiFid, 'wifiFid')">镜像包</span>)  
        </span>
          <span class="value" v-else-if="orderDetailData.wiFiVersion">{{
            orderDetailData.wiFiVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">蓝牙固件版本：</div>
        <div class="right">
          <span class="allowSkip" v-if="orderDetailData.btFid!=0">{{
            orderDetailData.btVersion
          }}
         (<span class="allowSkip" @click="downloadFile(orderDetailData.btFid, 'btFid')">镜像包</span>)    
        </span>
          <span class="value" v-else-if="orderDetailData.btVersion">{{
            orderDetailData.btVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">硬件版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.hwVersion">{{
            orderDetailData.hwVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">配置版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.cfgVersion">{{
            orderDetailData.cfgVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">系统版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.osVersion">{{
            orderDetailData.osVersion
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded && orderDetailData.product.hasIq">
        <div class="left">IQ二进制版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.iqVersion">{{ orderDetailData.iqVersion.code }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">固件校验码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.fwCheckSum">{{
            orderDetailData.fwCheckSum
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">系统校验码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.md5sum">{{
            orderDetailData.md5sum
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')" class="titleBox">
      <p class="title">校验信息</p>
      <el-button type="primary" size="mini" @click="updateCheckInfo" v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
        >修改</el-button
      >
    </div>
    <div v-else class="titleBox">
      <p class="title">校验信息</p>
      <el-button type="primary" size="mini" @click="updateWeight(orderDetailData.minWeight, orderDetailData.maxWeight, orderDetailData.duration)" v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
        >修改</el-button
      >
    </div>
    <ul v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')" class="ulBox clearFloat">
      <li v-if="isDataLoaded && orderDetailData.product.batterySupport">
        <div class="left">电池容量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.battery">{{ orderDetailData.battery }}mAh</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded && orderDetailData.product.batterySupport">
        <div class="left">电池曲线：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.batteryVersion">{{ orderDetailData.batteryVersion.code }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded">
        <div class="left">最低电量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.minBatt"
            >{{ orderDetailData.minBatt }}%</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded ">
        <div class="left">最高电量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.maxBatt"
            >{{ orderDetailData.maxBatt }}%</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">RSSI下限：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.rssi"
            >{{ orderDetailData.rssi }}dbm</span
          >
          <span v-else>0dbm</span>
        </div>
      </li>
      <li>
        <div class="left">RSSI上限：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.maxRssi"
            >{{ orderDetailData.maxRssi }}dbm</span
          >
          <span v-else>0dbm</span>
        </div>
      </li>
      <li>
        <div class="left" v-if="orderDetailData.product && orderDetailData.product.productType.code=='CARDVR'">上行吞吐量：</div>
        <div class="left" v-else>2.4G吞吐量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.bandwidth"
            >{{ orderDetailData.bandwidth }}Mbps</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left" v-if="orderDetailData.product && orderDetailData.product.productType.code=='CARDVR'">下行吞吐量：</div>
        <div class="left" v-else>5G吞吐量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.bandwidth2"
            >{{ orderDetailData.bandwidth2 }}Mbps</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded && orderDetailData.customer.id=='148759996952887296'"> <!-- 安防Mike客户 -->
        <div class="left">吞吐量上限：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.maxBandwidth"
            >{{ orderDetailData.maxBandwidth }}Mbps</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">有线吞吐量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.lanBandwidth"
            >{{ orderDetailData.lanBandwidth }}Mbps</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最小测距值：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.minDist"
            >{{ orderDetailData.minDist }}mm</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">最大测距值：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.maxDist"
            >{{ orderDetailData.maxDist }}mm</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded && (orderDetailData.product.btSupport || (orderDetailData.product.productType && orderDetailData.product.productType.code=='HEADPHONE'))">
        <div class="left">蓝牙名称：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.btName">{{
            orderDetailData.btName
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded">
        <div class="left">老化测试时长：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.duration"
            >{{ orderDetailData.duration }}分钟</span
          >
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <ul v-else class="ulBox clearFloat">      
      <li>
        <div class="left">裸机最小重量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.minWeight"
            >{{ orderDetailData.minWeight }}g</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">裸机最大重量：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.maxWeight"
            >{{ orderDetailData.maxWeight }}g</span
          >
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded">
        <div class="left">老化测试时长：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.duration"
            >{{ orderDetailData.duration }}分钟</span
          >
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <p class="title">客户定制信息</p>
      <el-button type="primary" size="mini" @click="updateCustomer" v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">自定义型号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customerModel">{{
            orderDetailData.customerModel
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">自定义版本：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.customerEdition">{{
            orderDetailData.customerEdition
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">产品规格：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.gauge">{{
            orderDetailData.gauge
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">厂商信息：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.vendor">{{
            orderDetailData.vendor
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')">
        <div class="left">默认密码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.defaultPassword">{{
            orderDetailData.defaultPassword
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')">
        <div class="left">PID：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.tuyaPid">{{
            orderDetailData.tuyaPid
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <p class="title">扩展信息</p>
      <el-button type="primary" size="mini" @click="updateExtendInfo" v-if="orderDetailData.status && orderDetailData.status.code=='READY' "
        >修改</el-button
      >
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">EAN：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.eanCode">{{
            orderDetailData.eanCode
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">UPC：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.upcCode">{{
            orderDetailData.upcCode
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">国家码：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.countryCode">{{
            orderDetailData.countryCode
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">CMIIT ID：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.cmiitId">{{
            orderDetailData.cmiitId
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">客户料号：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.partNumber">{{
            orderDetailData.partNumber
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">检料单：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.pickSlip">{{
            orderDetailData.pickSlip
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
      <li>
        <div class="left">客户PO：</div>
        <div class="right">
          <span class="value" v-if="orderDetailData.hqPo">{{
            orderDetailData.hqPo
          }}</span>
          <span v-else>-</span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <p v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')" class="title">扩展字段信息</p>
      <p v-else class="title">投料规则</p>
      <el-button type="primary" size="mini" @click="addProductionOrderExtendInfo"
        >新增</el-button
      >
    </div>
    <ul class="ulBox clearFloat" style="padding-top: 5px;">
      <li class="blockLi">
        <div class="right">
          <el-table
            class="myProductionOrder"
            stripe
            :data="productionOrderExtendData"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column label="配件名称"
              prop="fieldName" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fieldName">
                  {{scope.row.fieldName}}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="物料编码"
              prop="fieldKey" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fieldKey">{{ scope.row.fieldKey }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column :label="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER') ? '值' : '校验规则'"
              prop="fieldValue" min-width="80" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.fieldValue">{{ scope.row.fieldValue }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"
              class-name="operation" align="center" width="100px">
              <template slot-scope="scope">
                <el-tooltip
                  class="item" effect="dark" content="修改" placement="top" :open-delay="300">
                  <i v-if="scope.row.fieldKey" class="el-icon-edit" @click="updateProductionOrderExtendInfo($event, scope.row)"></i>
                </el-tooltip>
                <el-tooltip v-if="orderDetailData.status && orderDetailData.status.code=='READY'" 
                  class="item" effect="dark" content="删除" placement="top" :open-delay="300">
                  <i v-if="scope.row.fieldKey" class="el-icon-delete" @click="deleteProductionOrderExtendInfo($event, scope.row)"></i>
                </el-tooltip>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
    </ul>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <div v-if="dialogTitle == '烧录工单'" key="code">
          <div class="tips tipsBox">
            <span class="text">因外发邮件的频率限制，如未收到邮件通知请删除此单后重新发起。</span>
          </div>
        </div>
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <div v-if="dialogTitle == '修改工单数量'">
            <div class="tips tipsBox" style="margin-top: -20px; margin-left: -30px; margin-bottom: 15px; margin-right: -30px;">
              <span class="title" style="color:#E6A23C">警告：</span>
              <span class="text">修改后不能恢复，请谨慎使用此功能！</span>
            </div>
            <el-form-item label="裸机数量：" size="small" prop="quantity">
              <el-input-number
                v-model="dialogForm.quantity"
                :min="0"
                :precision="0"
                placeholder="组装工单裸机数量"
                :controls="false"
              ></el-input-number>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改组装单号'" key="code">
            <el-form-item label="组装单号：" size="small" prop="orderNumber">
              <el-input
                v-model="dialogForm.orderNumber"
                placeholder="输入新组装单号"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改SAP单号'" key="code">
            <el-form-item label="SAP单号：" size="small" prop="sapOrderNumber">
              <el-input
                v-model="dialogForm.sapOrderNumber"
                placeholder="PMC提供的生产工单号，一串数字的那个"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改送检批次'" key="code">
            <el-form-item label="送检批次：" size="small" prop="batchQuantity">
              <el-input
                v-model="dialogForm.batchQuantity"
                placeholder="每批次送检的裸机数量，如：100"
                clearable
              >
                <template slot="append">PCS/批</template>
              </el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改首件检验单'" key="code">
            <el-form-item label="首件前可生产数量：" size="small" prop="fai" label-width="135px">
              <el-input v-model="dialogForm.fai" placeholder="首件前可生产的数量，如：10" clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="首件检验单号：" size="small" prop="faiOrderNumber" label-width="135px">
              <el-input v-model="dialogForm.faiOrderNumber" placeholder="首件检验单号，确认首件检验通过以便批量生产。" clearable>
              </el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改批次抽检率'" key="code">
            <el-form-item label="抽检率：" size="small" prop="checkRate">
              <el-input
                v-model="dialogForm.checkRate"
                placeholder="每批次的抽检率"
                clearable
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改批次合格率'" key="code">
            <el-form-item label="合格率：" size="small" prop="qualifiedRate">
              <el-input
                v-model="dialogForm.qualifiedRate"
                placeholder="每批次抽检的合格率"
                clearable
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '烧录工单'" key="code">
            <el-form-item label="烧录工单：" size="small" prop="orderNumber">
              <el-input
                v-model="dialogForm.orderNumber"
                placeholder="输入Flash烧录工单"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-if="dialogTitle == '修改成品编码'" key="code">
            <el-form-item label="成品编码：" size="small" prop="itemCode">
              <el-input
                v-model="dialogForm.itemCode"
                placeholder="输入成品编码"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改计划交货时间'" key="date">
            <el-form-item label="交货日期：" size="small" prop="date">
              <el-date-picker
                v-model="dialogForm.date"
                type="date"
                placeholder="计划交货时间"
                value-format="yyyy-MM-dd"
                clearable
                :picker-options="$store.state.pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改开始生产时间'" key="dateTime">
            <el-form-item label="开始时间：" size="small" prop="dateTime">
              <el-date-picker
                v-model="dialogForm.dateTime"
                type="datetime"
                placeholder="输入开始生产时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                :picker-options="$store.state.pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改PE工程师'" key="pe">
            <el-form-item
              label="PE工程师："
              size="small"
              prop="processEngineerId"
            >
              <el-select
                v-model="dialogForm.processEngineerId"
                placeholder="选择PE工程师"
                clearable
                class="hiddenSelectDropdown"
                :popper-append-to-body="false"
                @visible-change="
                  selectVisible($event, 'processEngineer', 'PE工程师', 'editPE')
                "
              >
                <el-option
                  v-for="(item, index) in pullDownData.processEngineerList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改客户定制信息'" key="customer">
            <el-form-item label="自定义型号：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.customerModel"
                placeholder="客户自定义型号，如：Mixcder E9"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="自定义版本："
              size="small"
              prop="customerEdition"
            >
              <el-input
                v-model="dialogForm.customerEdition"
                placeholder="客户自定义版本，如：Black"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="产品规格：" size="small" prop="gauge">
              <el-input
                v-model="dialogForm.gauge"
                placeholder="如：英规、美规、欧规、豪华套装、一拖二等"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="厂商信息：" size="small" prop="vendor">
              <el-input
                v-model="dialogForm.vendor"
                placeholder="厂商信息，如：AONI"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')"
              label="默认密码："
              size="small"
              prop="defaultPassword"
            >
              <el-input
                v-model="dialogForm.defaultPassword"
                placeholder="默认密码，如：admin888"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')" label="PID：" size="small" prop="tuyaPid">
              <el-input readonly="true"
                v-model="dialogForm.tuyaPid"
                placeholder="PID，如：esx7auuil3xxxxxx"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改版本' && isDataLoaded && (orderDetailData.product.productType.code=='AI_PC' || orderDetailData.product.productType.code=='AI_SERVER')" key="version1">
            <el-form-item label="OS版本：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.osVersion"
                placeholder="如:JXX-JX-156-TU241KUJR100-001-H.bin"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="BIOS版本：" size="small" prop="customerModel">
              <el-input v-model="dialogForm.fwVersion"
                placeholder="如:HH-14.1-BI-TU241KUJR100-KF00C-001-B.bin" clearable >
              </el-input>
            </el-form-item>
            <el-form-item label="EC分位：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.cfgVersion"
                placeholder="如:HH-14.1-EC-TU241KUJR100-KF00C-001-B"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Key PartNum：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.md5sum"
                placeholder="如:KQ6-00168"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改版本' && isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER')" key="version">
            <el-form-item label="Flash固件：" size="small" prop="customerModel">
              <el-select v-if="orderDetailData.product.hasFw" v-model="dialogForm.fwVersion"
                placeholder="Flash固件版本" filterable clearable allow-create>
                <el-option
                  v-for="(item, index) in pullDownData.fwList"
                  :key="index" :label="item.customer? (item.version+'('+item.customer.name+')') : item.version" :value="item.version">
                </el-option>
              </el-select>
              <el-input v-else v-model="dialogForm.fwVersion"
                placeholder="如:V1.0.1" clearable >
              </el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded && orderDetailData.product.productType.code=='IPC'" label="OTA版本：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.otaVersion"
                placeholder="如:V2.0"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="MCU单片机：" size="small" prop="customerModel">
              <el-select v-if="isDataLoaded && orderDetailData.product.hasMcu" v-model="dialogForm.mcuVersion"
                placeholder="MCU版本" filterable clearable allow-create>
                <el-option
                  v-for="(item, index) in pullDownData.mcuList"
                  :key="index" :label="item.version" :value="item.version">
                </el-option>
              </el-select>
              <el-input v-else
                v-model="dialogForm.mcuVersion"
                placeholder="如:V0.0.1"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="WiFi网卡：" size="small" prop="customerModel">
              <el-select v-if="isDataLoaded && orderDetailData.product.hasWiFi" v-model="dialogForm.wiFiVersion"
                placeholder="WiFi网卡版本" filterable clearable allow-create>
                <el-option
                  v-for="(item, index) in pullDownData.wiFiList"
                  :key="index" :label="item.version" :value="item.version">
                </el-option>
              </el-select>
              <el-input v-else
                v-model="dialogForm.wiFiVersion"
                placeholder="如:V0.0.1"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="蓝牙版本：" size="small" prop="customerModel">
              <el-select v-if="isDataLoaded && orderDetailData.product.hasBt" v-model="dialogForm.btVersion"
                placeholder="Bluetooth蓝牙版本" filterable clearable allow-create>
                <el-option
                  v-for="(item, index) in pullDownData.btList"
                  :key="index" :label="item.version" :value="item.version">
                </el-option>
              </el-select>
              <el-input v-else
                v-model="dialogForm.btVersion"
                placeholder="如:V0.0.1"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="硬件版本：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.hwVersion"
                placeholder="如:V2020.08.13"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="配置版本：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.cfgVersion"
                placeholder="如:V1.001"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="系统版本：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.osVersion"
                placeholder="如:Android 7.0.1"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="IQ二进制版本：" size="small" prop="iqVersion" v-if="orderDetailData.product.hasIq">
              <el-select v-if="isDataLoaded" v-model="dialogForm.iqVersion"
                         placeholder="IQ二进制版本" filterable clearable allow-create>
                <el-option
                    v-for="(item, index) in pullDownData.iqVerList"
                    :key="index" :label="item.version" :value="item.id">
                </el-option>
              </el-select>
              <el-input v-else
                        v-model="dialogForm.iqVersion"
                        placeholder="如:V0.0.1"
                        clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="固件校验码：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.fwCheckSum"
                placeholder="如:2644393de78c668ba2379394d5fd9515"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="系统校验码：" size="small" prop="customerModel">
              <el-input
                v-model="dialogForm.md5sum"
                placeholder="如:2644393de78c668ba2379394d5fd9515"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改生产信息'" key="proInfo">
            <el-form-item label="SN模版" size="small" prop="snPrefix">
              <el-input
                v-model="dialogForm.snPrefix"
                placeholder="输入SN模版"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="流水长度" size="small" prop="snLen">
              <el-input
                :value="dialogForm.snLen"
                @input="onlyNumber($event, 'dialogForm', 'snLen')"
                placeholder="SN流水号长度"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="起始SN" size="small" prop="startSn">
              <el-input
                :value="dialogForm.startSn"
                @input="onlyNumber($event, 'dialogForm', 'startSn')"
                placeholder="输入起始SN"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改QC吞吐量'" key="verify">            
            <el-form-item label="2.4G吞吐量：" size="small" prop="qcBandwidth">
              <el-input
                :value="dialogForm.qcBandwidth"
                @input="bandwidthInput($event, 'dialogForm', 'qcBandwidth')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
            <el-form-item label="5G吞吐量：" size="small" prop="qcBandwidth2">
              <el-input
                :value="dialogForm.qcBandwidth2"
                @input="bandwidthInput($event, 'dialogForm', 'qcBandwidth2')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
            <el-form-item label="有线吞吐量：" size="small" prop="qcLanBandwidth">
              <el-input
                :value="dialogForm.qcLanBandwidth"
                @input="bandwidthInput($event, 'dialogForm', 'qcLanBandwidth')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改裸机称重'">
            <el-form-item label="最小重量：" size="small" prop="minWeight">
              <el-input
                :value="dialogForm.minWeight"
                @input="bandwidthInput($event, 'dialogForm', 'minWeight')"
                placeholder="单位：g，如：1010.0"
                clearable
              >
                <template slot="append">g</template>
              </el-input>
            </el-form-item>
            <el-form-item label="最大重量：" size="small" prop="maxWeight">
              <el-input
                :value="dialogForm.maxWeight"
                @input="bandwidthInput($event, 'dialogForm', 'maxWeight')"
                placeholder="单位：g，如：1020.5"
                clearable
              >
                <template slot="append">g</template>
              </el-input>
            </el-form-item>
            <el-form-item label="老化时长：" size="small" prop="duration">
              <el-input
                :value="dialogForm.duration"
                @input="bandwidthInput($event, 'dialogForm', 'duration')"
                placeholder="单位：分，如：240"
                clearable
              >
                <template slot="append">分钟</template>
              </el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改校验信息'">
            <el-form-item v-if="isDataLoaded && orderDetailData.product.batterySupport"
              label="电池容量：" size="small" prop="battery">
              <el-select v-model="dialogForm.battery" style="width: 250px"
                placeholder="电池容量" filterable clearable                
                @change="batteryChange">
                <el-option
                  v-for="(item, index) in pullDownData.batteryCapList"
                  :key="index" :label="item" :value="item">
                </el-option>
              </el-select><span style="width: 50px; border: 0; background-color: var(--bgPanel); padding: 0 0 0 10px; color: var(--textSecondary);">mAh</span>
            </el-form-item>
            <el-form-item v-if="isDataLoaded && orderDetailData.product.batterySupport"
              label="电池曲线：" size="small" prop="batteryVersion">
              <el-select v-model="dialogForm.batteryVersion" style="width: 250px"
                placeholder="电池曲线" filterable clearable>
                <el-option
                  v-for="(item, index) in pullDownData.batteryVerList"
                  :key="index" :label="item.code" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isDataLoaded"
              label="最低电量：" size="small" prop="minBatt">
              <el-input
                :value="dialogForm.minBatt"
                @input="minBattInput($event, 'dialogForm', 'minBatt')"
                placeholder="最低电量(单位：百分比)，如：80"
                clearable
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded"
              label="最高电量：" size="small" prop="maxBatt">
              <el-input
                :value="dialogForm.maxBatt"
                @input="maxBattInput($event, 'dialogForm', 'maxBatt')"
                placeholder="最高电量(单位：百分比)，如：80"
                clearable
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
            <el-form-item label="RSSI下限：" size="small" prop="rssi">
              <el-input
                :value="dialogForm.rssi"
                @input="rssiInput($event, 'dialogForm', 'rssi')"
                placeholder="信号衰减值dbm"
                clearable
              >
                <template slot="append">dbm</template>
              </el-input>
            </el-form-item>
            <el-form-item label="RSSI上限：" size="small" prop="maxRssi">
              <el-input
                :value="dialogForm.maxRssi"
                @input="rssiInput($event, 'dialogForm', 'maxRssi')"
                placeholder="信号衰减值dbm"
                clearable
              >
                <template slot="append">dbm</template>
              </el-input>
            </el-form-item>
            <el-form-item label="有线吞吐量：" size="small" prop="lanBandwidth">
              <el-input
                :value="dialogForm.lanBandwidth"
                @input="bandwidthInput($event, 'dialogForm', 'lanBandwidth')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="orderDetailData.product && orderDetailData.product.productType.code=='CARDVR' ? '上行吞吐量：' : '2.4G吞吐量：'" size="small" prop="bandwidth">
              <el-input
                :value="dialogForm.bandwidth"
                @input="bandwidthInput($event, 'dialogForm', 'bandwidth')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
            <el-form-item :label="orderDetailData.product && orderDetailData.product.productType.code=='CARDVR' ? '下行吞吐量：' : '5G吞吐量：'" size="small" prop="bandwidth2">
              <el-input
                :value="dialogForm.bandwidth2"
                @input="bandwidthInput($event, 'dialogForm', 'bandwidth2')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded && orderDetailData.customer.id=='148759996952887296'" label="吞吐量上限：" size="small" prop="maxBandwidth">
              <el-input
                :value="dialogForm.maxBandwidth"
                @input="bandwidthInput($event, 'dialogForm', 'maxBandwidth')"
                placeholder="吞吐量带宽(单位：Mbps，精确度0.2)，如：30"
                clearable
              >
                <template slot="append">Mbps</template>
              </el-input>
            </el-form-item>
            <el-form-item label="最小测距值：" size="small" prop="minDist">
              <el-input
                :value="dialogForm.minDist"
                @input="bandwidthInput($event, 'dialogForm', 'minDist')"
                placeholder="最小测距值：(单位：mm)，如：30"
                clearable
              >
                <template slot="append">mm</template>
              </el-input>
            </el-form-item>        
            <el-form-item label="最大测距值：" size="small" prop="maxDist">
              <el-input
                :value="dialogForm.maxDist"
                @input="bandwidthInput($event, 'dialogForm', 'maxDist')"
                placeholder="最大测距值：(单位：mm)，如：30"
                clearable
              >
                <template slot="append">mm</template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded && (orderDetailData.product.btSupport || (orderDetailData.product.productType && orderDetailData.product.productType.code=='HEADPHONE'))"
              label="蓝牙名称：" size="small" prop="btName">
              <el-input
                style="width: 250px"
                v-model="dialogForm.btName"
                placeholder="蓝牙名称，如：Mixcder E9"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item v-if="isDataLoaded"
              label="老化时长：" size="small" prop="duration">
              <el-input
                v-model="dialogForm.duration"
                placeholder="单位：分钟，如：240"
                clearable
              >
                <template slot="append">分钟</template>
              </el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改扩展信息'" key="extend">
            <el-form-item label="EAN：" size="small" prop="eanCode">
              <el-input
                v-model="dialogForm.eanCode"
                placeholder="EAN码，如：690123456789"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="UPC：" size="small" prop="upcCode">
              <el-input
                v-model="dialogForm.upcCode"
                placeholder="UPC码，如：69012345678"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="国家码：" size="small" prop="countryCode">
              <el-input
                v-model="dialogForm.countryCode"
                placeholder="国家码，如：CN"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="CMIIT ID：" size="small" prop="cmiitId">
              <el-input
                v-model="dialogForm.cmiitId"
                placeholder="CMIIT ID，如：2014CJ3296"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="客户料号：" size="small" prop="partNumber">
              <el-input
                v-model="dialogForm.partNumber"
                placeholder="客户料号，如：1481114"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="捡料单：" size="small" prop="pickSlip">
              <el-input
                v-model="dialogForm.pickSlip"
                placeholder="捡料单，如：BCS8010LHWM..A3"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="客户PO：" size="small" prop="hqPo">
              <el-input
                v-model="dialogForm.hqPo"
                placeholder="客户PO，如：OD20603785-1"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '新增扩展字段信息'" key="addProductionOrderExtend">
            <el-form-item label="配件名称：" size="small" prop="fieldName">
              <el-input
                v-model="dialogForm.fieldName"
                placeholder="如：LCD_SN"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="物料编码：" size="small" prop="fieldKey">
              <el-input
                v-model="dialogForm.fieldKey"
                placeholder="如填写LCD料号：'177010M0013566'"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item :label="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER') ? '值：' : '校验规则'" size="small" prop="fieldValue">
              <el-input type="textarea" :rows="5"
                v-model="dialogForm.fieldValue"
                placeholder='[{"start":"S13010A4", "len":16}, {"start":"SY130", "len":16},{"start":"LCD25", "len":16}]'
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div v-else-if="dialogTitle == '修改扩展字段信息'" key="updateProductionOrderExtend">
            <el-form-item label="TYPE：" size="small" prop="fieldName">
              <el-input
                v-model="dialogForm.fieldName"
                placeholder="如：4G版本号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="KEY：" size="small" prop="fieldKey">
              <el-input v-model="dialogForm.fieldKey" placeholder="如：4G_version" clearable></el-input>
            </el-form-item>            
            <el-form-item :label="isDataLoaded && (orderDetailData.product.productType.code!='AI_PC' && orderDetailData.product.productType.code!='AI_SERVER') ? '值：' : '校验规则'" size="small" prop="fieldValue">
              <el-input type="textarea" 
                :autosize="{minRows: 5, maxRows: 20}"
                v-model="dialogForm.fieldValue"
                placeholder="JSON字符串"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import { apiDownloadFile } from "@/api/filesUpload.js";
import { apiFirmwareList } from "@/api/firmwareManage.js";
import { apiProductBatteryCapacityList, apiProductBatteryVersionList } from "@/api/ProductionBattery.js";
import { apiProductIqSearch } from "@/api/ProductIq.js";
import {
  apiProductionOrderDetail,
  apiUpdateItemCode,
  apiUpdateOrderNumber,
  apiUpdateSapOrderNumber,
  apiOutwardFw,
  apiUpdateStartDateTime,
  apiUpdatePlanFinishDateTime,
  apiProductionOrderUpdateQuantity,
  apiUpdateMembers,
  apiUpdateCustomization,
  apiUpdateVersion,
  apiUpdateSNprefix,apiDeviceUpsert,
  apiUpdateCheckInfo, apiUpdateFai,
  apiUpdateQcBandwidth,
  apiUpdateExtendInfo,
  apiUpdateBatchQuantity,
  apiUpdatCheckRate,
  apiUpdateQualifiedRate,
  apiSearchProductionOrderExtend,
  apiProductionOrderUpdateWeight,
  apiAddProductionOrderExtend,
  apiUpdateProductionOrderExtend,
  apiDeleteProductionOrderExtend
} from "@/api/productionOrder.js";
import myDialog from "@/components/myDialog.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  components: {
    myDialog,
    orderTableSelect,
  },
  data: function() {
    return {
      isDataLoaded : false,
      pullDownData: {
        processEngineerList: [],
        fwList:[],
        mcList:[],
        wiFiList:[],
        btList:[],
        batteryVerList:[],
        batteryCapList:[],
        iqVerList:[]
      },
      productionOrderExtendData:[],
      orderDetailData: {},
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        orderNumber:[{ required: true, message: "单号不能为空！", trigger: "change" }],
        itemCode: [
          { required: true, message: "成品编码不能为空！", trigger: "change" },
        ],
        dateTime: [
          {
            required: true,
            message: "开始生产时间不能为空！",
            trigger: "change",
          },
        ],        
        date: [
          {
            required: true,
            message: "交货日期不能为空！",
            trigger: "change",
          },
        ],
        processEngineerId: [
          { required: true, message: "PE工程师不能为空！", trigger: "change" },
        ],
        eanCode: [
          {
            min: 9,
            max: 13,
            message: "长度在 9 到 13 个字符",
            trigger: "change",
          },
        ],
        upcCode: [
          {
            min: 12,
            max: 12,
            message: "长度在 12 个字符",
            trigger: "change",
          },
        ],
        snPrefix: [
          { required: true, message: "SN模板不能为空！", trigger: "blur" },
        ],
        snLen: [
          { required: true, message: "流水长度不能为空！", trigger: "blur" },
        ],
        startSn: [
          { required: true, message: "起始SN不能为空！", trigger: "blur" },
        ],
        battery: [
          { required: true, message: "电池容量不能为空！", trigger: "change" },
        ],
        batteryVersion: [
          { required: true, message: "电池曲线版本不能为空！", trigger: "change" },
        ],
        iqVersion: [
          { required: true, message: "IQ二进制版本不能为空！", trigger: "change" },
        ],
        minBatt: [
          { required: true, message: "最低电量不能为空！", trigger: "change" },
        ],
        btName: [
          { required: true, message: "蓝牙名称不能为空！", trigger: "change" },
        ],
        fieldName: [
          { required: true, message: "TYPE不能为空！", trigger: "blur" },
        ],
        fieldKey: [
          { required: true, message: "名称不能为空！", trigger: "blur" },
        ],
        fieldValue: [
          { required: true, message: "值不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 订单详情数据
    async getProductionOrderDetail(callback) {
      const res = await apiProductionOrderDetail({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        this.orderDetailData = res.data;        
        this.$parent.detailData = res.data;
        this.$parent.detailStatus = res.data.status;
        this.getProductionOrderExtendSearch();
        if (callback) callback();
      }
      this.isDataLoaded = true;
    },
    outwardFw(orderNumber) {
      this.dialogTitle = "烧录工单";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        orderNumber: orderNumber,
      };
    },
    upsert() {
      const h = this.$createElement;
              this.$msgbox({
                title: `将当前工单已生产的产品信息上传给高德`,
                message: h("div", null, [
                  h("span", null, `请输入工单号:【`),
                  h("i", { style: "color: var(--themeColor)" }, this.orderDetailData.orderNumber),
                  h("span", null, `】以确认上传！`)
                ]),
                showCancelButton: true,
                confirmButtonText: `上传`,
                cancelButtonText: "取消",
                closeOnClickModal: false,
                showInput: true,
                beforeClose: (action, instance, done) => {
                  if (action === 'confirm') {
                    if (instance.inputValue === this.orderDetailData.orderNumber) {
                      done()
                    } else {
                      this.$message({
                        type: "warning",
                        message: `输入错误，请重新输入或取消！`
                      })
                    }
                  } else {
                    done()
                  }
                }
              }).then(async () => {
                const res = await apiDeviceUpsert({
                  id: this.orderDetailData.id
                });
                if (res.code==0) {
                  this.$message({
                    message: res.msg + "，"+res.data,
                    type: "success",
                  });
                }
                this.getProductionOrderDetail();
              })
    },
    editOrderNumber(orderNumber) {
      this.dialogTitle = "修改组装单号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        orderNumber: orderNumber,
      };
    },
    editSapOrderNumber(sapOrderNumber) {
      this.dialogTitle = "修改SAP单号";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        sapOrderNumber,
      };
    },
    editFai(quantity, orderNumber) {
      this.dialogTitle = "修改首件检验单";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        fai: quantity,
        faiOrderNumber: orderNumber
      };
    },
    editBatchQuantity(batchQuantity) {
      this.dialogTitle = "修改送检批次";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        batchQuantity: batchQuantity,
      };
    },
    editCheckRate(rate) {
      this.dialogTitle = "修改批次抽检率";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        checkRate: rate,
      };
    },
    editQualifiedRate(rate) {
      this.dialogTitle = "修改批次合格率";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        qualifiedRate: rate,
      };
    },
    // 修改成品编码
    editItemCode(code) {
      this.dialogTitle = "修改成品编码";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        itemCode: code,
      };
    },
    // 修改计划交货时间
    editPlanFinishDate(date) {
      this.dialogTitle = "修改计划交货时间";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        date,
      };
    },
    // 修改开始生产时间
    editStartDate(dateTime) {
      this.dialogTitle = "修改开始生产时间";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        dateTime,
      };
    },
    // 修改裸机称重
    async updateWeight(min, max, duration) {
      this.dialogTitle = "修改裸机称重";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        minWeight: min,
        maxWeight: max,
        duration: duration
      }
    },
    editQcBandwidth(qcBandwidth, qcBandwidth2,qcLanBandwidth) {
      this.dialogTitle = "修改QC吞吐量";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        qcBandwidth,
        qcBandwidth2,
        qcLanBandwidth
      };
    },
    editQuantityBtn(quantity) {
      this.dialogTitle = "修改工单数量";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        quantity,
      };
    },
    // 修改pe工程师
    editPEEngineer(data) {
      this.dialogTitle = "修改PE工程师";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: this.tabPaneValue,
        processEngineerId: data ? data.id : undefined,
      };
      this.pullDownData.processEngineerList = [
        data
          ? {
              name: data.name,
              id: data.id,
            }
          : {},
      ];
    },
    // 修改客户定制信息
    updateCustomer() {
      this.dialogTitle = "修改客户定制信息";
      this.$refs.myDialog.dialogVisible = true;
      let {
        customerModel,
        customerEdition,
        gauge,
        vendor,
        defaultPassword,
        tuyaPid,
      } = this.orderDetailData;
      this.dialogForm = {
        id: this.tabPaneValue,
        customerModel,
        customerEdition,
        gauge,
        vendor,
        defaultPassword,
        tuyaPid,
      };
    },
    // 修改版本
    async updateVersion() {
      let res = await apiFirmwareList({
        customerId: this.orderDetailData.customer.id,
        productId: this.orderDetailData.product.id,
        productionOrderId: this.orderDetailData.id,
        type: "Flash"
      });
      if (res.code == 0) {
        this.pullDownData.fwList = res.data;
      }
      res = await apiFirmwareList({
        customerId: this.orderDetailData.customer.id,
        productId: this.orderDetailData.product.id,
        productionOrderId: this.orderDetailData.id,
        type: "MCU"
      });
      if (res.code == 0) {
        this.pullDownData.mcuList = res.data;
      }
      res = await apiFirmwareList({
        customerId: this.orderDetailData.customer.id,
        productId: this.orderDetailData.product.id,
        productionOrderId: this.orderDetailData.id,
        type: "WiFi"
      });
      if (res.code == 0) {
        this.pullDownData.wiFiList = res.data;
      }
      res = await apiFirmwareList({
        customerId: this.orderDetailData.customer.id,
        productId: this.orderDetailData.product.id,
        productionOrderId: this.orderDetailData.id,
        type: "Bluetooth"
      });
      if (res.code == 0) {
        this.pullDownData.btList = res.data;
      }
      // IQ二进制版本下拉
      if (this.orderDetailData.product && this.orderDetailData.product.hasIq) {
        const resIq = await apiProductIqSearch({ productId: this.orderDetailData.product.id });
        if (resIq.code == 0) {
          // 已禁用的 IQ 版本不在下拉框显示（当前工单已选中的版本除外，保证回显）
          const currentIqId = this.orderDetailData.iqVersion ? this.orderDetailData.iqVersion.id : null;
          this.pullDownData.iqVerList = (resIq.data || []).filter(item => item.enable || item.id === currentIqId);
        }
      } else {
        this.pullDownData.iqVerList = [];
      }

      this.dialogTitle = "修改版本";
      this.$refs.myDialog.dialogVisible = true;
      let {
        mcuVersion,
        wiFiVersion,
        btVersion,
        fwVersion,
        hwVersion,
        cfgVersion,
        osVersion,
        md5sum,fwCheckSum
      } = this.orderDetailData;
      let iqVersion = 0;
      if (this.orderDetailData.iqVersion) {
        iqVersion = this.orderDetailData.iqVersion.id;
      }
      this.dialogForm = {
        id: this.tabPaneValue,
        mcuVersion,
        wiFiVersion,
        btVersion,
        fwVersion,
        hwVersion,
        cfgVersion,
        osVersion,
        md5sum,fwCheckSum,
        iqVersion
      };
    },
    // 修改生产信息
    updateProInfo() {
      this.dialogTitle = "修改生产信息";
      this.$refs.myDialog.dialogVisible = true;
      let {
        snPrefix,
        snLen,
        startSn,
      } = this.orderDetailData;
      this.dialogForm = {
        id: this.tabPaneValue,
        snPrefix,
        snLen,
        startSn,
      };
    },

    // 修改校验信息
    async updateCheckInfo() {
      const res = await apiProductBatteryCapacityList({
        productId: this.orderDetailData.product.id
      });
      if (res.code == 0) {
        this.pullDownData.batteryCapList = res.data;
      }
      if (this.orderDetailData.battery) {
        const res1 = await apiProductBatteryVersionList({
          productId: this.orderDetailData.product.id,
          capacity: this.orderDetailData.battery
        });
        if (res1.code == 0) {
          this.pullDownData.batteryVerList = res1.data;
        }
      } else {        
          this.pullDownData.batteryVerList = [];
      }

      this.dialogTitle = "修改校验信息";
      this.$refs.myDialog.dialogVisible = true;
      let {
        bandwidth,
        bandwidth2,
        maxBandwidth,
        rssi,
        maxRssi,
        lanBandwidth,
        qcLanBandwidth,
        qcBandwidth,
        qcBandwidth2,
        btName,duration,
        minBatt,
        maxBatt,
        battery,
        minDist,
        maxDist
      } = this.orderDetailData;
      let batteryVersion = 0;
      if(this.orderDetailData.batteryVersion) {
        batteryVersion = this.orderDetailData.batteryVersion.id;
      }
      this.dialogForm = {
        id: this.tabPaneValue,
        bandwidth,
        bandwidth2,
        maxBandwidth,
        rssi,
        maxRssi,
        lanBandwidth,
        qcLanBandwidth,
        qcBandwidth,
        qcBandwidth2,
        btName,duration,
        minBatt,
        maxBatt,
        battery,
        batteryVersion,
        minDist,
        maxDist
      };
    },
    async batteryChange(value) {
      this.$set(this.dialogForm, "batteryVersion", null);
      this.pullDownData.batteryVerList=[];
      const res = await apiProductBatteryVersionList({
        productId: this.orderDetailData.product.id,
        capacity: value
      });
      if (res.code == 0) {
        this.pullDownData.batteryVerList = res.data;
      }
    },
    // 修改扩展信息
    updateExtendInfo() {
      this.dialogTitle = "修改扩展信息";
      this.$refs.myDialog.dialogVisible = true;
      let {
        eanCode,
        upcCode,
        countryCode,
        cmiitId,
        partNumber,
        pickSlip,
        hqPo,
      } = this.orderDetailData;
      this.dialogForm = {
        id: this.tabPaneValue,
        eanCode,
        upcCode,
        countryCode,
        cmiitId,
        partNumber,
        pickSlip,
        hqPo,
      };
    },
    // 表格数据
    async getProductionOrderExtendSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.productionOrderExtendData = [];
      }
      const res = await apiSearchProductionOrderExtend({
        productionOrderId: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.productionOrderExtendData = res.data;
        if (callback) callback();
      }
    },
    // 新增扩展字段信息
    addProductionOrderExtendInfo() {
      this.dialogTitle = "新增扩展字段信息";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 修改扩展字段信息
    updateProductionOrderExtendInfo(e,row) {
      this.dialogTitle = "修改扩展字段信息";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm={
        fieldName:row.fieldName,
        fieldKey:row.fieldKey,
        fieldValue:row.fieldValue
      }
    },
    // SN && Uuid下载
    downloadFile(fid, fileName, secretKey) {
      let a = document.createElement("a");
      a.download = fileName + "下载";
      a.href = apiDownloadFile(fid, secretKey);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 对话框提交
    submitData(title, force) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "修改工单数量") {
            res = await apiProductionOrderUpdateQuantity({
              // id: this.tabPaneValue,
              ...this.dialogForm,
              force
            });
          } else if (title == "修改组装单号") {
            res = await apiUpdateOrderNumber({
              ...this.dialogForm,
            });
          } else if (title == "修改SAP单号") {
            res = await apiUpdateSapOrderNumber({
              ...this.dialogForm,
            });
          } else if (title == "修改送检批次") {
            res = await apiUpdateBatchQuantity({
              ...this.dialogForm,
            });
          } else if (title == "修改批次抽检率") {
            res = await apiUpdatCheckRate({
              ...this.dialogForm,
            });
          } else if (title == "修改首件检验单") {
            res = await apiUpdateFai({
              ...this.dialogForm,
            });
          } else if (title == "修改批次合格率") {
            res = await apiUpdateQualifiedRate({
              ...this.dialogForm,
            });
          } else if (title == "修改成品编码") {
            res = await apiUpdateItemCode({
              ...this.dialogForm,
            });
          } else if (title=="修改计划交货时间") {
            res = await apiUpdatePlanFinishDateTime({
              ...this.dialogForm,
            });
          } else if (title == "修改开始生产时间") {
            res = await apiUpdateStartDateTime({
              ...this.dialogForm,
            });
          } else if (title == "修改PE工程师") {
            res = await apiUpdateMembers({
              ...this.dialogForm,
            });
          } else if (title == "修改客户定制信息") {
            res = await apiUpdateCustomization({
              ...this.dialogForm,
            });
          } else if (title == "修改版本") {
            res = await apiUpdateVersion({
              ...this.dialogForm,
              force: force
            });
          } else if (title == "修改生产信息") {
            if (force) {
              res = await apiUpdateSNprefix({
                ...this.dialogForm,
                force
              });
              if (res.code == 1024) {
                this.submitData(title, true);
              } else if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getProductionOrderDetail();
                this.$message({
                  message: "共有【"+res.data+"】个SN修改成功！",
                  type: "success",
                });
              }
              return;
            } else {
              const h = this.$createElement;
              this.$msgbox({
                title: `仅对【未生产】的有效`,
                message: h("div", null, [
                  h("span", null, `请输入工单号:【`),
                  h("i", { style: "color: var(--themeColor)" }, this.orderDetailData.orderNumber),
                  h("span", null, `】以确认修改！修改SN模版仅对当前工单未生产SN的产品有效。`)
                ]),
                showCancelButton: true,
                confirmButtonText: `修改`,
                cancelButtonText: "取消",
                closeOnClickModal: false,
                showInput: true,
                beforeClose: (action, instance, done) => {
                  if (action === 'confirm') {
                    if (instance.inputValue === this.orderDetailData.orderNumber) {
                      done()
                    } else {
                      this.$message({
                        type: "warning",
                        message: `输入错误，请重新输入或取消！`
                      })
                    }
                  } else {
                    done()
                  }
                }
              }).then(async () => {
                res = await apiUpdateSNprefix({
                  ...this.dialogForm
                });
                if (res.code == 0) {
                  this.$refs.myDialog.dialogVisible = false;
                  this.getProductionOrderDetail();
                  this.$message({
                    message: "共有【"+res.data+"】个SN修改成功！",
                    type: "success",
                  });
                } else if (res.code == 1024) {
                  this.$confirm(res.msg, "强制执行", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }).then(() => {
                    this.submitData(title, true);
                  });
                }
              })
            }
          } else if (title == "修改裸机称重") {            
            const res = await apiProductionOrderUpdateWeight({
              ...this.dialogForm,
              id: this.orderDetailData.id
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getProductionOrderDetail();
            }
          } else if (title == "修改校验信息") {
            if(this.dialogForm.maxBatt < this.dialogForm.minBatt){
              this.$message({
                      message: "最高电量不能低于最低电量！",
                      type: "warning",
                    });
                    return;
            }
            res = await apiUpdateCheckInfo({
              ...this.dialogForm,
              id: this.tabPaneValue
            });
          } else if (title == "修改QC吞吐量") {
            res = await apiUpdateQcBandwidth({
              ...this.dialogForm,
              id: this.tabPaneValue
            });
          } else if (title == "修改扩展信息") {
            res = await apiUpdateExtendInfo({
              ...this.dialogForm,
            });
          } else if (title == "烧录工单") {
            res = await apiOutwardFw({
              ...this.dialogForm,
            });
          } else if (title == "新增扩展字段信息") {
            res = await apiAddProductionOrderExtend({
              ...this.dialogForm,
              id:this.tabPaneValue,
              productionOrderId: this.tabPaneValue
            });
            
          } 
          else if (title == "修改扩展字段信息") {
            res = await apiUpdateProductionOrderExtend({
                ...this.dialogForm,
                id: this.tabPaneValue,
                productionOrderId: this.tabPaneValue
              });
            
          } 

          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.getProductionOrderDetail();
            if(title == "新增扩展字段信息" || title == "修改扩展字段信息"){
              this.getProductionOrderExtendSearch();
            }
            if (title == "烧录工单") {
              this.$message({
                message: "Flash烧录任务已发起，结果将发送到您的邮箱，请留意！",
                type: "warning",
              });
            }
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else if(res.code == 1024) {
              this.$confirm(res.msg, "强制执行", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.submitData(title, true);
              });
          }
        } else {
          return false;
        }
      });
    },
    // 删除扩展字段信息
    deleteProductionOrderExtendInfo(e,row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = "请输入字段名称:【";
      const st = row.fieldKey;
      this.$msgbox({
        title: `提示！`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确定删除！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {

        const res = await apiDeleteProductionOrderExtend({
          fieldName:row.fieldName,
          fieldKey:row.fieldKey,
          fieldValue:row.fieldValue,
          id: this.tabPaneValue,
          productionOrderId: this.tabPaneValue
        });
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.getProductionOrderExtendSearch();
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 输入框只能输入数字
    onlyNumber(value, formName, name) {
      this.$set(this[formName], name, this.$formatPositive(value));
    },
    // 允许一位小数
    onlyDecimals(value, formName, name) {
      this.$set(this[formName], name, this.$formatDecimals(value));
    },
    
    // 吞吐量带宽
    rssiInput(value, formName, name) {
      let val = value.replace(/[^\-\d]/g, ""); // 只能输入-和数字
      val = val.replace(/^[1-9]/g, ""); // 不能以1-9开头
      val = val.replace(/\\-{2,}/g, "-"); // -只能保留一个
      val = val.replace(/(\d)\\-/g, "$1"); // 数字后面不能接-，不能出现类似-11-2,12-，11-23
      val = val.replace(/-(0+)/g, "0"); // 不能出现-0,-001,-0001类似
      val = val.replace(/^0+(\d)/, "0"); // 第一位0开头，0后面为数字，则过滤掉，取0
      val = val.replace(/(-\d{3})\d*/, '$1') // 最多保留3位整数
      this.$set(
        this[formName],
        name,
        val
      );
    },
    // 吞吐量带宽
    bandwidthInput(value, formName, name) {
      this.$set(
        this[formName],
        name,
        value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, "$1")
      );
    },
    // 最低电量为整数,0-100
    minBattInput(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue > 100) {
        newValue = 100;
      } else if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, parseInt(newValue));
    },
    // 最高电量为整数,0-100
    maxBattInput(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue > 100) {
        newValue = 100;
      } else if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, parseInt(newValue));
    },
    // 电池容量
    batteryInput(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, parseInt(newValue));
    },
    // 弹框选择
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        // console.log(orderName, labelName)
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 弹框表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      if (origin == "editPE") {
        this.$set(this.dialogForm, `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      }
    },
  }
};
</script>

<style lang="less" scoped>
  .pass {
    color: #67C23A;
  }
  .ng {    
    color: #F56C6C;
  }
  .icon-fasong {
    margin-left: 5px;
  }
</style>